import { useRef, useEffect, debounce } from "@";

// Hook for debounced search functionality
export const useDebouncedSearch = (
  onSubmit,
  searchValues,
  defaultSearchValues = null,
) => {
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

    if (defaultSearchValues && defaultSearchValues !== searchValues) {
      return;
    }

    const debouncedSubmit = debounce(() => {
      onSubmit();
    }, 700);

    debouncedSubmit();

    return () => {
      debouncedSubmit.cancel();
    };
  }, [searchValues]);
};
